import { Suspense } from 'react';
import { useNavigate, useParams, Navigate } from 'react-router-dom';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { TopicForm } from '@/admin/components/TopicForm';
import type { TopicEditPageQuery } from '@/__generated__/TopicEditPageQuery.graphql';

/**
 * Query to fetch topic data for editing
 */
const topicEditPageQuery = graphql`
  query TopicEditPageQuery($slug: String!) {
    topic(slug: $slug) {
      ...TopicForm_topic
    }
  }
`;

function TopicEditPageContent({ slug }: { slug: string }) {
  const navigate = useNavigate();
  const data = useLazyLoadQuery<TopicEditPageQuery>(topicEditPageQuery, { slug });

  if (!data.topic) {
    return <Navigate to="/admin/topics" replace />;
  }

  return (
    <TopicForm
      topic={data.topic}
      onSuccess={() => navigate('/admin/topics')}
      onCancel={() => navigate('/admin/topics')}
    />
  );
}

export function TopicEditPage() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return <Navigate to="/admin/topics" replace />;
  }

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center py-20">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-indigo-500 border-t-transparent" />
        </div>
      }
    >
      <TopicEditPageContent slug={slug} />
    </Suspense>
  );
}
